import Vue from './vue'
import VueApexCharts from 'vue-apexcharts'
import Demo from './Demo.vue'
import './styles/custom.scss'
import  './tracking'

Vue.config.productionTip = false
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

new Vue({
  apolloProvider: Vue.$apolloProvider,
  render: h => h(Demo)
}).$mount('#app');
